import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, Global } from '@emotion/react';
import { isMobile } from 'react-device-detect';
import { DEFAULT_BACKGROUND_COLOR, DEFAULT_LINK_COLOR } from '../styles/colors';
export const GlobalStylesComponent = () => {
    return (_jsx(Global, { styles: css(
        // add mobile-only global styles:
        isMobile
            ? css `
              * {
                user-select: none;
              }
            `
            : undefined, css `
          * {
            box-sizing: border-box;
            /**
             * By default, disable overscroll-behavior everywhere to avoid confusing drag/scroll behaviors on mobile.
             * Then, enable overscroll-behavior for specific scrollable areas that benefit from it.
             * (Note that overscroll-behavior may be overridden in other areas of the codebase.)
             */
            overscroll-behavior: none;
            /**
             * Disable contextual menus ("callouts") on mobile.
             */
            -webkit-touch-callout: none;
            /**
             * Use transparent color to make tap highlights invisible. Seems to be a feature primarily on Android.
             */
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          }
          .MuiPaper-root {
            overscroll-behavior: auto;
          }
          .MuiDialogContent-root {
            overscroll-behavior: auto;
          }
          body {
            background-color: ${DEFAULT_BACKGROUND_COLOR};
            margin: 0;
          }
          a:link {
            color: ${DEFAULT_LINK_COLOR};
          }
          a:visited {
            color: ${DEFAULT_LINK_COLOR};
          }
          a:active {
            color: white;
          }
          a:hover {
            color: white;
          }
        `) }));
};
